import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UserMetricInstance} from 'src/app/models/user/Metric/UserMetricInstance';
import {BaseComponent} from "../../../../BaseComponent";
import {AggregateFunctionTypeEnum, ChartTypesEnum} from "../../../../../enums/dashboard/ChartsEnum";
import {ValueChangedEvent as LookupValueChangedEvent} from "devextreme/ui/lookup";
import {ValueChangedEvent as SelectBoxValueChangedEvent} from "devextreme/ui/select_box";

@Component({
  selector: 'app-chart-metrics-table',
  templateUrl: './chart-metrics-table.component.html',
  styleUrls: ['./chart-metrics-table.component.css', '../chart-form-edit.component.css']
})
export class ChartMetricsTableComponent extends BaseComponent {
  @Output() dataChanged = new EventEmitter<unknown>();
  @Input() selectedMetrics!: UserMetricInstance[];

  functionTypesValues: string[];

  /**
   * List of all the possible options contained in the ChartTypesEnum
   * @protected
   */
  protected chartTypes: string[];

  constructor() {
    super();
    this.functionTypesValues = Object.values(AggregateFunctionTypeEnum);
    this.chartTypes = Object.keys(ChartTypesEnum);
  }

  parseChartType = (value: string) => {
    return this.translate.instant('CHART_CREATION.' + value);
  };

  reorderItem = ($event: any) => {
    if ($event.toIndex < this.selectedMetrics.length && $event.toIndex < this.selectedMetrics.length) {
      this.selectedMetrics.splice($event.toIndex, 0, this.selectedMetrics.splice($event.fromIndex, 1)[0]);
      this.dataChanged.emit();
    }
  };

  translateFunctionType = (functionType: string) => {
    return this.translate.instant('CHART_CREATION.CHART_TYPES.' + functionType);
  }


  setSelectorValue(event: LookupValueChangedEvent | SelectBoxValueChangedEvent, x: any) {
    x.setValue(event.value);
  }
}
